module.exports = __webpack_public_path__ + "static/media/TRAINING_EVENING_SMALL.45c2995e.jpg";